// extracted by mini-css-extract-plugin
module.exports = {"link_wrapper":"styles_link_wrapper__1mvEZ","link_btn":"styles_link_btn__3TnlX"};